export class EventNavigationCategory {
    categoryId: string;
    categoryName: string;
    categoryLinks: CategoryLinks[];
}

export class CategoryLinks {
    linkIcon: string;
    linkPage: string;
    linkSegment: string;
    linkName: string;
    active: boolean;
}

export class NavData {
    page: string;
    segment: string;
  }


// WEBPACK FOOTER //
// ./src/models/eventNavigation.model.ts